import { useEffect } from 'react';

import { getViewerCountryCode } from '~/features/internationalization/utils/get-viewer-geo-codes';

import { initSessionReplay } from '../utils/init-session-replay';

type Options = {
  /**
   * If false, opt out for this render. Useful for the search trigger where
   * activation is event-driven (e.g. only init when a user starts typing or
   * opens the search drawer).
   */
  enabled?: boolean;
};

/**
 * Page-level opt-in for Amplitude Session Replay capture. Safe to call from
 * any client component; initialization is idempotent and gated by env, geo,
 * and Segment readiness inside `initSessionReplay`.
 *
 * Scope is intentionally page-level (not `_app.tsx`) so we can keep Session
 * Replay limited to the B2C surfaces approved in CONENG-2258.
 */
export function useSessionReplay({ enabled = true }: Options = {}) {
  useEffect(() => {
    if (!enabled) return;

    void initSessionReplay({ countryCode: getViewerCountryCode() });
  }, [enabled]);
}
